import { render, staticRenderFns } from "./TimeBlock.vue?vue&type=template&id=b33d9c4c&scoped=true"
import script from "./TimeBlock.vue?vue&type=script&lang=js"
export * from "./TimeBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33d9c4c",
  null
  
)

export default component.exports